import Cookies from 'js-cookie';
import cottonFlagManager from './featureFlags/cotton';
import {
  COTTON_OAUTH_CALLBACK, COTTON_V1_FORCE_CONNECT, COTTON_V1_PASSIVE_CONNECT, COTTON_DISCONNECT,
} from './cottonApis';

export const SKIP_PASSIVE_AUTH_SESSIONS = ['CONSENT'];
export const ALLOWED_AUTH_SESSIONS = ['CONSENT', 'LOGIN FULL'];
// Resolves the cotton-shield base for OAuth redirects (always same-origin).
export const base = () => window.location.origin;

export const forceLoginLink = (url) => {
  // Use the cotton-shield callback path when the APT cotton flag is enabled
  const { isCottonEnabled } = cottonFlagManager;
  const callbackPath = isCottonEnabled ? COTTON_OAUTH_CALLBACK : '/oauth/callback';
  const redirect = `${window.origin}${callbackPath}`;
  const oauthRoot = new URL('https://oauth.xfinity.com/oauth/authorize');
  oauthRoot.searchParams.set('client_id', 'my-account-web');
  oauthRoot.searchParams.set('response_type', 'code');
  oauthRoot.searchParams.set('prompt', 'login');
  oauthRoot.searchParams.set('redirect_uri', redirect);
  oauthRoot.searchParams.set('state', url);
  return oauthRoot.toString();
};
export const isTargetAuthEnabled = () => Cookies.get('dss_mw_ta_enabled') === '1';
export const isHintCookieAvailable = () => !!Cookies.get('r-hint');

/** Returns the current page URL for use in OAuth redirect parameters */
const getCurrentUrl = () => window.location.href;

/** Builds OAuth URL using URLSearchParams for consistent parameter handling */
const buildOAuthUrl = (basePath, path, continueUrl) => {
  const url = new URL(`${window.location.origin}${basePath}${path}`);
  url.searchParams.set('continue', continueUrl);
  return url.toString();
};

/** Redirects user to forced auth via browser window with account selection */
export const forceLoginV2 = ({ basePath = '' } = {}) => {
  const afterAuthContinueURL = getCurrentUrl();
  const forceConnectUrl = buildOAuthUrl(
    basePath,
    '/oauth/force_connect_v2',
    afterAuthContinueURL,
  );
  const disconnectUrl = buildOAuthUrl(
    basePath,
    '/oauth/disconnect',
    forceConnectUrl,
  );
  window.location.replace(disconnectUrl);
};

/** Redirects user to passive auth via browser window with account selection */
export const passiveLoginV2 = ({ basePath = '' } = {}) => {
  const afterAuthContinueURL = getCurrentUrl();
  const passiveConnectUrl = buildOAuthUrl(
    basePath,
    '/oauth/passive_connect_v2',
    afterAuthContinueURL,
  );
  window.location.replace(passiveConnectUrl);
};

const FORCE_LOGIN_PROMPT = 'select_billing_account login';
const PASSIVE_LOGIN_PROMPT = 'select_billing_account_auto';

/** Builds the OAuth query string for the APT (v1) login endpoints */
const buildAuthQuery = prompt => new URLSearchParams({
  prompt,
  continue: getCurrentUrl(),
}).toString();

/** Builds the Cotton v1 force_connect URL for the given continue URL */
export const buildCottonForceConnectUrl = (href) => {
  const query = new URLSearchParams({
    prompt: FORCE_LOGIN_PROMPT,
    continue: href,
  }).toString();
  return `${base()}${COTTON_V1_FORCE_CONNECT}?${query}`;
};

/** Redirects user to forced auth via the APT (v1) endpoint with account selection */
export const forceLoginV1 = () => {
  const forceConnectUrl = encodeURIComponent(buildCottonForceConnectUrl(getCurrentUrl()));
  // Send the browser to the CIMA login screen after we destroy the MAW session.
  window.location.replace(`${base()}${COTTON_DISCONNECT}?continue=${forceConnectUrl}`);
};

/** Redirects user to passive auth via the APT (v1) endpoint with account selection */
export const passiveLoginV1 = () => {
  const authQuery = buildAuthQuery(PASSIVE_LOGIN_PROMPT);
  window.location.replace(`${base()}${COTTON_V1_PASSIVE_CONNECT}?${authQuery}`);
};
